/**
 * TO REFACTOR
 *
 *
 * move to use render-preview.store !!
 * */

export default {
    namespaced: true,
    state: () => ({
        preview: false,
        pageMode: false,
    }),
    mutations: {
        setPreview(state, preview) {
            state.preview = preview;
        },
        setPageMode(state, pageMode) {
            state.pageMode = pageMode;
        },
    },
};
